import React from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Product = ({ details }) => {
  let course = details;
  let navigate = useNavigate();
  const courseDet = () => {
    if (course.button == "Enroll Now") {
      navigate("/coursedetails");
    }
  };
  return (
    <>
      <Card className="shadow">
        <Card.Img src={course.image} alt="" />
        <Card.Body>
          <p className="mb-0 fw-bold">{course.name}</p>
          <p className="">{course.description}</p>
        </Card.Body>
        <Card.Footer>
          <Button variant="primary" className="px-5 w-100" onClick={courseDet}>
            {course.button}
          </Button>
        </Card.Footer>
      </Card>
    </>
  );
};

export default Product;
